import React, {useState} from "react";
import {useSearchParams} from "react-router-dom";
import {VerifyService} from "../../service/VerifyService";
import './InitiateVerification.scss'
import {ButtonComponent} from "../../components/common/button/ButtonComponent";

const InitiateVerificationPage: React.FC = () => {

    const [searchParams] = useSearchParams();

    const [loading, setLoading] = useState(false);

    const onClick = async () => {
        setLoading(true)
        const verificationService = VerifyService.getInstance()
        const result = await verificationService.initiateVerification()
        if (result && result.verificationId) {
            if (searchParams.get("app")) {
                window.location.href =
                    `${window.location.protocol}//${window.location.host}/${result.verificationId}?app=true`
            } else {
                window.location.href =
                    `${window.location.protocol}//${window.location.host}/${result.verificationId}`
            }

        }
    }

    return !loading ?
                <div className="iv-container">
                    <ButtonComponent label="Start verification" onButtonClick={() => onClick()}/>
                </div>
                :
                <div className="iv-container font-white">
                    Starting verification...
                </div>


}

export default InitiateVerificationPage;